import { useState } from 'react';

import ChatFilter from './chat-filter';
import ChatItemList from './chat-item-list';
import ChatSearch from './chat-search';
import CreateNewChat from './create-new-chat';

import { ChatFilterTypeEnum } from '../../../../shared/constants/enums';

import './styles.less';

import { FetchChatParams, UnreadCountData } from '../../models';

export type ChatListProps = {
  newUnreadCount: UnreadCountData | undefined;
  updateMessageControl: () => void;
};

const ChatList = ({ newUnreadCount, updateMessageControl }: ChatListProps) => {
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [searchValue, setSearchValue] = useState<string>('');
  const [fetchChatData, setFetchChatData] = useState<FetchChatParams | undefined>();
  const [chatFilterValue, setChatFilterValue] = useState<ChatFilterTypeEnum>(ChatFilterTypeEnum.All);

  return (
    <>
      <ChatFilter
        setFetchChatData={setFetchChatData}
        searchValue={searchValue}
        chatFilterValue={chatFilterValue}
        setChatFilterValue={setChatFilterValue}
      />

      <div className="chat-list-main">
        <ChatSearch
          setFetchChatData={setFetchChatData}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          setPageNumber={setPageNumber}
          chatFilterValue={chatFilterValue}
        />

        <CreateNewChat
          updateMessageControl={updateMessageControl}
          setSearchValue={setSearchValue}
          setPageNumber={setPageNumber}
          setFetchChatData={setFetchChatData}
          chatFilterValue={chatFilterValue}
        />
      </div>

      <ChatItemList
        newUnreadCount={newUnreadCount}
        updateMessageControl={updateMessageControl}
        chatSearchValue={searchValue}
        pageNumber={pageNumber}
        setPageNumber={setPageNumber}
        fetchChatData={fetchChatData}
        chatFilterValue={chatFilterValue}
      />
    </>
  );
};

export default ChatList;
